var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import "@frameworks/shared-library/stylesheets/components/Orderbook/common/MutualFundTransactionsTable/MutualFundTransactionsTable.scss";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import emptyFolder from "@frameworks/shared-library/assets/images/markets/emptyFolder.svg";
var MutualFundTransactionsTable = function (props) {
    var _a;
    var _b = props.numberOfDataItemsToShowViewAllAfter, numberOfDataItemsToShowViewAllAfter = _b === void 0 ? 5 : _b, _c = props.showShimmer, showShimmer = _c === void 0 ? false : _c;
    var _d = __read(React.useState([]), 2), transactionsData = _d[0], setTransactionsData = _d[1];
    React.useEffect(function () {
        if (!!(props === null || props === void 0 ? void 0 : props.data) && props.data.length) {
            if (!!(props === null || props === void 0 ? void 0 : props.showViewAll)) {
                setTransactionsData(props.data.slice(0, numberOfDataItemsToShowViewAllAfter));
            }
            else {
                setTransactionsData(__spreadArray([], __read(props.data), false));
            }
        }
    }, [props.data]);
    return (React.createElement("div", { className: "primary-mutual-fund-transactions-table-container" }, showShimmer ? (React.createElement(GenericTableShimmer, { rowCount: 5, columnCount: 6, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-1-1" })) : !!(props === null || props === void 0 ? void 0 : props.data) && ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) ? (React.createElement(React.Fragment, null,
        React.createElement(GenericTable, __assign({}, props, { parentClassName: "common-compact-table-wrapper", sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", rowClassName: "hand_cursor", sortArrowHighlightingColor: "#696682", numberOfDataItemsToShow: !!(props === null || props === void 0 ? void 0 : props.showViewAll)
                ? numberOfDataItemsToShowViewAllAfter
                : undefined })),
        props.showViewAll &&
            !!(props === null || props === void 0 ? void 0 : props.data) &&
            props.data.length > numberOfDataItemsToShowViewAllAfter ? (React.createElement(EdButton, { btnTyp: "text-only", onClick: function () { return !!(props === null || props === void 0 ? void 0 : props.viewAllOnClick) && (props === null || props === void 0 ? void 0 : props.viewAllOnClick()); }, className: "DMSanN_16_400 txt-han-blue tables-viewAll-button mgt-15 mgb-15", value: React.createElement("span", { className: "d-flex align-items-center gap-2 mgl-12" },
                React.createElement("span", { className: "text-decoration-underline" }, "View All"),
                React.createElement("i", { className: "edel-icon-arrow-right" })) })) : (React.createElement(React.Fragment, null)))) : (React.createElement("div", { className: "custom-error-state" },
        React.createElement(Errormsg, { image: emptyFolder, msg: " ", customComp: props.mfCustomError ? (React.createElement("div", null, props.mfCustomError)) : (React.createElement("div", { className: "error-state-button-bar flexCenter" },
                React.createElement("p", { className: "DMSanN_14_400" }, "You don't seem to have any transactions as of now in Mutual Funds."),
                React.createElement(EdButton, { btnTyp: "tomato", onClick: function () {
                        return (props === null || props === void 0 ? void 0 : props.errorScreenBtnCallback) &&
                            (props === null || props === void 0 ? void 0 : props.errorScreenBtnCallback());
                    }, value: "Invest Now!", className: "d-flex align-items-center justify-content-center DMSanN_13_500" }))) })))));
};
export default MutualFundTransactionsTable;
